<template>
  <div v-show="visibility" class='-grid-cell-component'>
    <cell-label v-show='!editable' :value="inputValue" />
    <div v-show="editable" class="-grid-cell-time-picker -grid-cell-component" style="width: 100%">
      <input ref="input" :disabled="disabled" class="-grid-cell-time-picker__input" :class="inputClass()" :value="inputValue" :readonly="!typeable" />
      <span class="-grid-cell-time-picker__icon" :class="iconClass()" @click.stop="onTrigger"></span>
    </div>
  </div>
</template>

<script>
import CellLabel from '../CellLabel/CellLabelView';

export default {
  name: 'CellTimePicker',
  components: {
    'cell-label': CellLabel,
  },
  props: {
    checkEditableFunction: {
      type: Function,
      default: null,
    },
    checkDisabledFunction: {
      type: Function,
      default: null,
    },
    checkVisibilityFunction: {
      type: Function,
      default: null,
    },
    value: { type: [String, Date], default: '' }, // 부모로부터 입력 받은 날짜
    typeable: { type: Boolean, default: false },
  },
  data() {
    return {
      editable: true,
      disabled: false,
      visibility: true,
      inputValue: this.value,
    };
  },
  computed: {
    displayLabel() {
    },
  },
  mounted() {
  },
  methods: {
    setEditable(rowData, columnName, dataset, grid) {
      if (this.checkEditableFunction) {
        this.editable = this.checkEditableFunction(rowData, columnName, dataset, grid);
      }
    },
    setDisabled(rowData, columnName, dataset, grid) {
      if (this.checkDisabledFunction) {
        this.disabled = this.checkDisabledFunction(rowData, columnName, dataset, grid);
      }
    },
    setVisibility(rowData, columnName, dataset, grid) {
      if (this.checkVisibilityFunction) {
        this.visibility = this.checkVisibilityFunction(rowData, columnName, dataset, grid);
      }
    },
    handleBeforeDestroy() {
      (this.$el && this.$el.parentNode)? this.$el.parentNode.removeChild(this.$el):'';
    },
    inputClass() {
      // return 'vdp-datepicker input';
    },
    iconClass() {
      return '-grid-cell-time-picker__icon';
    },
    onTrigger() {
      if (this.disabled) {
        return;
      }
      this.portal = utils.getComponentPortal('time-picker');
      if (this.portal) {
        this.bindEvents();
        this.portal.setTimeStr(this.inputValue);
        this.portal.show(this.inputValue, this.getOpenPosition());
      }
    },
    bindEvents() {
      const component = this.portal;
      if (component) {
        this.binded = true;
        component.$on('close', this.onClose);
        component.$on('confirm', this.onConfirm);
      }
    },
    unbindEvents() {
      const component = this.portal;
      if (component && this.binded) {
        component.$off('close', this.onClose);
        component.$off('confirm', this.onConfirm);
        this.binded = false;
      }
      this.portal = null;
    },
    onClose() {
      this.unbindEvents();
    },
    onConfirm(value) {
      this.unbindEvents();
      let strValue = value;
      if (value.constructor !== String) {
        const HH = value.HH? `${value.HH}`: '';
        const mm = value.mm? `:${value.mm}`: '';
        const ss = value.ss? `:${value.ss}`: '';
        strValue = `${HH}${mm}${ss}`;
      }
      this.$emit('confirm', strValue);
    },
    setTimeStr(value) {
      // if (this.binded) {
      //   this.portal.toggleItemOuter();
      // }
      this.inputValue = value;
    },
    getOpenPosition() {
      const bounds = this.$refs.input.getBoundingClientRect();
      return {
        x: bounds.left,
        y: bounds.top + bounds.height,
      };
    },
  },
  beforeDestroy() {
    this.unbindEvents();
  }
};
</script>

<style scoped>
</style>
